import { useQuery } from '@pinia/colada';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { TimeFilter } from '@tallo/utility';

import propertyInquiryService from '../services/property-inquiry.service';

export function getPropertyInquiriesQueryKey(propertyId: string, filter?: TimeFilter) {
  const key = ['property', propertyId, 'inquiries'];

  if (filter) {
    key.push(filter);
  }

  return key;
}

export function usePropertyInquiriesQuery() {
  const route = useRoute();
  const router = useRouter();

  const propertyId = computed(() => route.params.propertyId as string);
  const selectedTimeFilter = computed({
    get: () => (route.query.timeFilter as TimeFilter) || TimeFilter.LAST_30_DAYS,
    set: (value: TimeFilter) => {
      router.replace({
        query: {
          ...route.query,
          timeFilter: value,
        },
      });
    },
  });

  const query = useQuery({
    key: () => getPropertyInquiriesQueryKey(propertyId.value, selectedTimeFilter.value),
    query: () => propertyInquiryService.getAllInquiriesByProperty(propertyId.value, selectedTimeFilter.value),
  });

  return {
    ...query,
    selectedTimeFilter,
    inquiries: computed(() => query.data.value || []),
  };
}
